import { render, staticRenderFns } from "./TrangXemDonVi.vue?vue&type=template&id=2e004d3c&"
import script from "./TrangXemDonVi.vue?vue&type=script&lang=js&"
export * from "./TrangXemDonVi.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports